import { render, staticRenderFns } from "./canshuduibi.vue?vue&type=template&id=76a88ffa&scoped=true"
import script from "./canshuduibi.vue?vue&type=script&lang=js"
export * from "./canshuduibi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a88ffa",
  null
  
)

export default component.exports